// index.tsx
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { PageProps } from '../../../../types/navigationProperties';
import { Box } from '@mui/material';
import Footer from '../../../../components/Footer';
import MasonryImageList from '../../../../components/MasonryImageList';
import { GalleryImage } from '../../../../types/galleryImage';
import { displayErrorToast } from '../../../../utils/toasts';
import { useNavigate, useLocation } from "react-router-dom";
import { getCustomShopGallery } from '../../../../services/CustomShopGalleriesServiceProvider';
import LoaderSpinner from '../../../../components/LoaderSpinner';
import { SetButtonCallbackFunction } from '../../../../types/callback';
import { SEO } from '../../../../components/SEO';
import { MetaTag } from '../../../../services/SEOServiceProvider';
import aboutPage from '../../../../assets/img/about_page.jpg';

export default function CustomShopDetails({ props, setPageName, imageSize, metaTags }: { props: PageProps, setPageName: SetButtonCallbackFunction, imageSize: string, metaTags: MetaTag[] }) {
    const location = useLocation();
    const { state } = location;
    const { slug } = useParams();
    const navigate = useNavigate();
    const language = props.language;
    const [loading, setLoading] = React.useState('images' in state ? true : false);
    const [data, setData] = React.useState<GalleryImage[]>();
    const [metaTag, setMetaTag] = React.useState<MetaTag>();

    React.useEffect(() => {
        setPageName('custom-shop-details');
        let metaTagData = metaTags !== undefined && metaTags.filter((item: MetaTag) => item.page === 'custom-shop-details' );
        if(metaTagData && metaTagData.length > 0) {
            let customShopDetailsPageMetaTag: MetaTag = {...metaTagData[0]} as MetaTag;
            customShopDetailsPageMetaTag.url = window.location.href;
            customShopDetailsPageMetaTag.image = aboutPage;
            setMetaTag(customShopDetailsPageMetaTag);
        }

        (async () => {
            try {
                if(!('images' in state)) {
                    const customShopData = await getCustomShopGallery(slug !== undefined ? slug : '', imageSize);
                    console.log(customShopData);
                    setData(customShopData.custom_shop_gallery_images);
                    if(metaTagData && metaTagData.length > 0) {
                        let customShopDetailsPageMetaTag: MetaTag = {...metaTagData[0]} as MetaTag;
                        customShopDetailsPageMetaTag.url = window.location.href;
                        customShopDetailsPageMetaTag.image = aboutPage;
                        customShopDetailsPageMetaTag.title = customShopData.title.value;
                        setMetaTag(customShopDetailsPageMetaTag);
                    }
                } else {
                    console.log('setting data from state');
                    setData(state.images);
                    if(metaTagData && metaTagData.length > 0) {
                        let customShopDetailsPageMetaTag: MetaTag = {...metaTagData[0]} as MetaTag;
                        customShopDetailsPageMetaTag.url = window.location.href;
                        customShopDetailsPageMetaTag.image = aboutPage;
                        customShopDetailsPageMetaTag.title = state.title.value;
                        setMetaTag(customShopDetailsPageMetaTag);
                    }
                }
            } catch(error) {
                displayErrorToast(error);
            } finally {
                console.log(state.images);
                setLoading(false);
            }
        })();
    }, [language, state, slug, setPageName, imageSize, metaTags]);

    const handleBackClick = () => {
        navigate('/custom-shop');
    };

    return loading ? (
        <div>
            <SEO metaTag={metaTag} />
            <LoaderSpinner loading={loading} />
        </div>
    ) : (
        <Box>
            <SEO metaTag={metaTag} />
            <MasonryImageList images={data} clickBack={handleBackClick} />
            <Footer {...props} />
        </Box>
    );
}